import { TWoofyChatApiVersion } from 'nove8/constants/root-constants'

export const toWoofyChatApiVersion = (
  isCoachFlow: boolean,
): TWoofyChatApiVersion => (isCoachFlow ? 'v2' : 'v1')
